export const WAVOL1 = "https://www.vol-1.web-almanac.com/"
export const WAVOL2 = "https://www.vol-2.web-almanac.com/"
export const WAVOL3 = "https://vol-3.web-almanac.com/"
export const WABOT = "https://t.me/WebAlmanacBot"
export const WATG = "https://t.me/web_almanac"
export const WANOTES = "https://vol-3.web-almanac.com/notes"